// removed by extract-text-webpack-plugin
module.exports = {"card":"tNQZumotDTb7Yvy6dBwle","uploadWrapper":"_3NgR8sUJbJL4mlfYx-GMKk","fileList":"_2oeuB9ROZ9NKKrxGpvOvDZ","file":"_13WdNaDaHeZsNRKq3830si","fileExt":"_1iDKvD8IDkYqbtGXTZkIbP","deleteIcon":"_1p25p8NmLmM17FvS21QSj1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DebtPhaseDocuments/styles.css
// module id = 1066
// module chunks = 0